module.exports = __webpack_public_path__ + "img/quxiao.8f2618d0.png";